function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPowerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 173081",
    transform: "translate(-485.979 -67.688)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 679",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(485.979 67.688)",
    style: {
      fill: "#ffffff"
    },
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21182",
    d: "m274.772 131.6-.453 5.208 3.623-1.132-3.169 7.925.453-5.208-3.623 1.132z",
    transform: "translate(219.209 -61.912)",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerIcon);
export default __webpack_public_path__ + "static/media/PowerIcon.2de1a20bcee2687b379988663b788bda.svg";
export { ForwardRef as ReactComponent };